export default __webpack_public_path__ + "static/fall36-e8be2171507abd8c24cda2a28f3688c1.webp";